class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];

    this.allSearchInputs.forEach((input) => {
      allSearchForms.push(input.form);
      input.addEventListener('focus', this.onInputFocus.bind(this)); // 各inputにfocusイベントをバインド
      input.addEventListener('input', this.onInput.bind(this)); // 各inputにinputイベントをバインド
    });
    // フォームが複数ある場合にのみリセットイベントをバインド
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => {
      if (form) form.addEventListener('reset', this.onFormReset.bind(this));
    });
  }

  onFormReset(event) {
    if (typeof super.onFormReset === "function") {
      super.onFormReset(event); // 親クラスに onFormReset があれば呼び出す
    }
    
    if (typeof super.shouldResetForm === "function" && super.shouldResetForm()) { // 親クラスに shouldResetForm があれば確認
      this.keepInSync('', event.target); // フォームリセット時に同期を保持
    }
  }

  onInput(event) {
    const target = event.target;
    if (target instanceof HTMLInputElement) { // target が input 要素であることを確認
      this.keepInSync(target.value, target); // 入力値を同期
    }
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen && typeof event.target.scrollIntoView === "function") {
      event.target.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value; // 入力内容を他の検索フィールドに同期
      }
    });
  }
}

customElements.define('main-search', MainSearch);

document.addEventListener("DOMContentLoaded", function() {
  const resetButton = document.querySelector(".reset__button");
  const searchInput = document.querySelector(".search__input");

  // reset__button が存在する場合のみ、イベントリスナーを追加
  if (resetButton) {
    resetButton.addEventListener("click", function(event) {
      event.preventDefault(); // デフォルトのリセット動作を防ぐ
      searchInput.value = ""; // 検索フィールドを空に設定
    });
  }
});

